import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React from 'react';
import Pet from '@spa/shared/svg/pet';
import { ListItem, List } from './styles';
import NoPets from '@spa/shared/svg/no-pets';
import Couples from '@spa/shared/svg/couples';
import Smoking from '@spa/shared/svg/smoking';
import NoSmoking from '@spa/shared/svg/no-smoking';
import NoCouples from '@spa/shared/svg/no-couples';
import DomesticStudent from '@spa/shared/svg/domestic-student';
import OccasionalGuests from '@spa/shared/svg/occasional-guests';
import NoOccasionalGuests from '@spa/shared/svg/no-occasional-guests';
import CalendarMinimumStay from '@spa/shared/svg/calendar-minimum-stay';
import InternationalStudent from '@spa/shared/svg/international-student';
import CalendarShortTermPenalty from '@spa/shared/svg/calendar-short-term-penalty';
import FemaleGender from '@spa/shared/svg/female-gender';
import MaleGender from '@spa/shared/svg/male-gender';
import NoProfessionalsAlt from '@spa/shared/svg/no-professionals-alt';
import NoStudents from '@spa/shared/svg/no-students';
import Persons from '@spa/shared/svg/persons';
export var getRentalConditions = function getRentalConditions(_ref) {
  var minimumStay = _ref.minimumStay,
    shortTermPenaltyAmount = _ref.shortTermPenaltyAmount,
    shortTermPenaltyPrice = _ref.shortTermPenaltyPrice,
    extraGuestsAmountStandardContract = _ref.extraGuestsAmountStandardContract,
    extraGuestsAmountFixedUnitaryContract = _ref.extraGuestsAmountFixedUnitaryContract,
    extraGuestsFormattedAmount = _ref.extraGuestsFormattedAmount,
    overnightGuestsAllowed = _ref.overnightGuestsAllowed,
    requirementsList = _ref.requirementsList,
    petsAllowed = _ref.petsAllowed,
    smokingAllowed = _ref.smokingAllowed,
    isCouplesAllowed = _ref.isCouplesAllowed,
    gender = _ref.gender,
    t = _ref.t,
    originsList = _ref.originsList,
    occupationsList = _ref.occupationsList;
  var baseConditions = [{
    icon: CalendarMinimumStay,
    translationKey: 'Minimum stay',
    translationValues: {
      count: minimumStay
    },
    order: true
  }];
  var hasShortTermPenalty = shortTermPenaltyAmount && shortTermPenaltyAmount > 0;
  return [].concat(baseConditions, _toConsumableArray(hasShortTermPenalty ? [{
    icon: CalendarShortTermPenalty,
    translationKey: 'Short term penalty',
    translationValues: {
      days: shortTermPenaltyAmount,
      amount: shortTermPenaltyPrice || ''
    },
    order: true
  }] : []), _toConsumableArray(extraGuestsAmountStandardContract > 0 || extraGuestsAmountFixedUnitaryContract > 0 ? [{
    icon: Persons,
    translationKey: 'Extra per tenant {{amount}}',
    translationValues: {
      amount: extraGuestsFormattedAmount || '0'
    },
    order: true
  }] : []), _toConsumableArray(overnightGuestsAllowed ? [{
    icon: OccasionalGuests,
    translationKey: 'Overnight guests allowed',
    order: true
  }] : [{
    icon: NoOccasionalGuests,
    translationKey: 'Overnight guests allowed',
    className: 'text-strike-through',
    order: false
  }]), [{
    icon: isCouplesAllowed ? Couples : NoCouples,
    translationKey: 'Couples allowed',
    className: isCouplesAllowed ? '' : 'text-strike-through',
    order: isCouplesAllowed
  }, {
    icon: petsAllowed ? Pet : NoPets,
    translationKey: 'Pets allowed',
    className: petsAllowed ? '' : 'text-strike-through',
    order: petsAllowed
  }, {
    icon: smokingAllowed ? Smoking : NoSmoking,
    translationKey: 'Smoking allowed',
    className: smokingAllowed ? '' : 'text-strike-through',
    order: smokingAllowed
  }], _toConsumableArray(gender !== null && gender !== void 0 && gender.length ? [{
    icon: gender.includes('males') ? FemaleGender : MaleGender,
    translationKey: gender.includes('males') ? 'Females only' : 'Males only',
    order: true
  }] : []), _toConsumableArray(originsList !== null && originsList !== void 0 && originsList.length ? [{
    icon: originsList.includes('domestic') ? InternationalStudent : DomesticStudent,
    translationKey: originsList.includes('domestic') ? 'International students only' : 'Domestic students only',
    order: true
  }] : []), _toConsumableArray(occupationsList !== null && occupationsList !== void 0 && occupationsList.length ? occupationsList.filter(function (occupation) {
    return occupation != 'unknown';
  }).map(function (occupation) {
    return {
      icon: occupation === 'professional-placement' ? NoProfessionalsAlt : NoStudents,
      translationKey: occupation === 'professional-placement' ? 'Professionals allowed' : occupation === 'undergraduate' ? 'Undergraduate students allowed' : 'Postgraduate students allowed',
      className: 'text-strike-through',
      order: false
    };
  }) : []), _toConsumableArray(requirementsList !== null && requirementsList !== void 0 && requirementsList.length ? [{
    translationKey: 'Requirements',
    content: __jsx(React.Fragment, null, __jsx("h3", null, t('Provide documents')), __jsx(List, null, requirementsList.map(function (requirement, index) {
      return __jsx(ListItem, {
        key: index
      }, requirement);
    }))),
    order: true
  }] : [])).sort(function (a, b) {
    return a.order && !b.order ? -1 : !a.order && b.order ? 0 : 1;
  });
};